import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { JobSeekerService } from 'src/app/job-seeker/job-seeker.service';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { UtilsService } from 'src/app/utils.service';
import { MenuService } from '../../services/menu.service';


@Component({
  selector: 'app-dashboard-menu-list',
  templateUrl: './dashboard-menu-list.component.html',
  styleUrl: './dashboard-menu-list.component.scss'
})
export class DashboardMenuListComponent {
  @Input() menuCustom: any = [];
  @Input() role: any = "";
  public supportActive: boolean = false;
  public supportVisible: boolean = false;
  public openDashboard: boolean = false;
  public profileData: any = {};
  menuDisplayStatus: boolean = true;
  @Input() collapsed = false;
  matri_menu: any = {
    /* "matri": {
      "title": "Matrimony",
      "icon": "fa-solid fa-heart",
      "active": "",
      "iconType": 'fa',
      "svgPath": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "subMenu": [
        {
          "title": "Bureau Details",
          "link": "/vendor/bureau-profile",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true
        },
        {
          "title": "Matrimonial Profiles",
          "link": "/vendor/matrimony-list",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true
        },
        {
          "title": "Search Filters",
          "link": "/vendor/matri-search-filter",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true
        },
        {
          "title": "Visited",
          "link": "/vendor/visited",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/visit.svg",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "visited"
          }
        },
        {
          "title": "Shortlisted",
          "link": "/vendor/shortlisted-profiles",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/shortlisted.svg",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "shortlisted"
          }
        },
        {
          "title": "Blocked",
          "link": "/vendor/blocked-profiles",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/block.svg",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "blocked"
          }
        },
        {
          "title": "Interested profiles",
          "link": "/vendor/interested",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/int-rec.svg",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "My Interests"
          }
        },
        {
          "title": "Shared profiles",
          "link": "/vendor/shared-profiles",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "shared-profiles"
          }
        },
        {
          "title": "Members visited you",
          "link": "/vendor/members-visited-you",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "members-visited-you"
          }
        },
        {
          "title": "Requested contact details",
          "link": "/vendor/requested-contacts",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true,
          "queryParams": {
            "status": "shared-profiles"
          }
        },
        {
          "title": "Matched Profiles",
          "link": "/vendor/matrimony-list",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true
        },


      ]

    }, */

    "jobs": {
      "title": "JOBS",
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Jobs-dash.svg",
      //"icon": "fa-solid fa-briefcase",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      //"iconType": 'fa',
      // "svgPath": "",
      "subMenu": [
        {
          "title": "Company Profile",
          "link": "/vendor/vendor-company-profile",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Company-Profile.svg",
          "active": "",
          "show": true
        },
        {
          "title": "My Employees",
          "link": "/vendor/employee/employee-list",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Human-Resources-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Interview Panel",
          "link": "/vendor/interviewer-list",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Interview-Panel.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Jobs Posted",
          "link": "/vendor/job-list",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Jobs-posted.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Online Exam",
          "link": "/vendor/schedule-list",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Online-exam.svg",
          "active": "",
          "show": true
        },

        {
          "title": "Applied Jobs",
          "link": "/vendor/vendor-applied-jobs",
          "icon": "",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": false
        }
      ]
    },

    "jobs_db": {
      "title": "Resumes Repository",
      "icon": "fa-solid fa-file-lines",
      "active": "",
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Resumes-Repository.svg",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "subMenu": [
        {
          "title": "Search Repository",
          "link": "/vendor/job-profile",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Search-Repository.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Profiles Repository",
          "link": "/vendor/candidate-profile-status",
          "icon": "",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Profiles-Repository.svg",
          "show": true
        }
      ]
    },
    /* "advertisements": {
      "title": "ADVERTISEMENTS",
      "icon": "fa-solid fa-bullhorn",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Advertss.svg",
      "subMenu": [
        {
          "title": "Adverts",
          "link": "/vendor/advertise-list",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Advertise.svg",
          "active": "",
          "show": true
        }
      ]
    }, */
   /*  "hrms": {
      "title": "HRMS",
      "icon": "fa-solid fa-user-clock",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/HRMS-team-svg-icon-1.svg",
      "subMenu": [
        {
          "title": "HRMS Dashboard",
          "link": "/vendor/hrms-dashboard",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath": "/assets/images/icon/dashboard-svg-icon-2.svg",
          "show": true
        },
        {
          "title": "Employees Directory",
          "link": "/vendor/emp-directory",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Employees-Directory-svg-icon-1.svg",
          "active": "",
          "show": true

        },
        {
          "title": "Organisation Chart",
          "link": "/vendor/org-chat",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Employees-Directory-svg-icon-1.svg",
          "active": "",
          "show": true

        },
        {
          "title": "My Employees",
          "link": "/vendor/employee/employee-list",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Human-Resources-svg-icon-1.svg",
          "active": "",
          "show": true
        },

        {
          "title": "Leave Requests",
          "link": "/vendor/leave-req",
          "icon": "fa fa-user-circle",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Leave-Requests-svg-icon-1.svg",
          "active": "",
          "show": true
        },
       
        {
          "title": "Shift Requests",
          "link": "/vendor/shift-req",
          "iconType": "svg",
          "icon": "fa fa-calendar-check",
          "active": "",
          "svgPath": "/assets/images/icon/Shift-requests-svg-icon-1.svg",
          "show": true
        },
        

        {
          "title": "Attachments Library",
          "link": "/vendor/reimbursement-attachments",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath": "/assets/images/icon/Attachments-Library-svg-icon-1.svg",
          "show": true
        },

        {
          "title": "Reimbursements",
          "link": "/vendor/reimbursement-list",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath": "/assets/images/icon/Reimbursements-svg-icon-1.svg",
          "show": true
        },
       

      
        {
          "title": "Attendance",
          "link": "/vendor/emp-attendance-list",
          "icon": "fa fa fa-calendar-check",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Attendance-svg-icon-1.svg",
          "active": "",
          "show": true

        },
        {
          "title": "Time sheet",
          "link": "/vendor/time-sheet",
          "icon": "fa-solid fa-clock",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Timesheet-svg-icon-1.svg",
          "active": "",
          "show": true
        },

        


        {
          "title": "Assets Management",
          "link": "/vendor/asset-management",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Assets-Management-svg-icon-1.svg",
          "active": "",
          "show": true

        },


        {
          "title": "Separation",
          "link": "/vendor/emp-seperation",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath": "/assets/images/icon/Employee-Separation-svg-icon-1.svg",
          "active": "",
          "show": true
        },
       
        {
          "title": "Service Request",
          "link": "/vendor/service-request-list",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Service-Requests-svg-icon-1.svg",
          "active": "",
          "show": true

        }
      ]
    }, */
    /* "approvals": {
      "title": "Approvals",
      "icon": "fa-solid fa-user-clock",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Approvals-svg-icon-1.svg",
      "subMenu": [
        {
          "title": "Leave Pending Approvals",
          "link": "/vendor/emp-pendings",
          "iconType": "svg",
          "icon": "fa fa-hourglass-half",
          "svgPath": "/assets/images/icon/Approvals-pending-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Shift Pendings",
          "link": "/vendor/shift-pendings",
          "iconType": "svg",
          "icon": "fa fa-calendar-check",
          "active": "",
          "svgPath": "/assets/images/icon/Shift-Pendings-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Reimbursement Approvals",
          "link": "/vendor/reimbursement-approval-pending",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath": "/assets/images/icon/Reimbursement-approvals-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Reimbursements Finance",
          "link": "/vendor/reimbursement-finance",
          "icon": "fa-solid fa-clock",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Finance-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Separation Approvals",
          "link": "/vendor/approval-managers",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath": "/assets/images/icon/Separation-approvals-svg-icon-1.svg",
          "active": "",
          "show": true
        },
      ]
    }, */
    "payments": {
      "title": "Payments",
      "icon": "fa-solid fa-indian-rupee-sign",
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Payments-cash.svg",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "subMenu": [
        {
          "title": "Transactions",
          "link": "/vendor/trans-list",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Transactions-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Invoice",
          "link": "/vendor/order-list",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Invoice-receipt.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Permissions",
          "link": "/vendor/job-features",
          "icon": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Payments.svg",
          "active": "",
          "show": true
        }
      ]
    },

    "finance": {
      "title": "Reimbursements Finance",
      "icon": "fa-solid fa-user-clock",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "iconType": 'fa',
      "svgPath": "",
      "subMenu": [
        {
          "title": "Reimbursements",
          "link": "/vendor/reimbursement-finance",
          "icon": "fa-solid fa-clock",
          "iconType": 'fa',
          "svgPath": "",
          "active": "",
          "show": true
        }

      ]
    },
 "approvalsEmp": {
      "title": "Approvals",
      "icon": "fa-solid fa-user-clock",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "iconType": 'fa',
      "svgPath": "",
      "subMenu": [
         {
          "title": "Leave Pending Approvals",
          "link": "/vendor/emp-pendings",
          "iconType": "svg",
          "icon": "fa fa-hourglass-half",
          "svgPath": "/assets/images/icon/Approvals-pending-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Shift Pendings",
          "link": "/vendor/shift-pendings",
          "iconType": "svg",
          "icon": "fa fa-calendar-check",
          "active": "",
          "svgPath": "/assets/images/icon/Shift-Pendings-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Separation Approvals",
          "link": "/vendor/approval-managers",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath":"/assets/images/icon/Separation-approvals-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Reimbursement Approvals",
          "link": "/vendor/reimbursement-approval-pending",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath":"/assets/images/icon/Reimbursement-approvals-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Rtw Pendings",
          "link": "/vendor/rtw-pendings",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Service-Requests-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Transport Pendings",
          "link": "/vendor/transport-pendings",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Service-Requests-svg-icon-1.svg",
          "active": "",
          "show": true
        }
        

      ]
    },
    "notifications": {
      "title": "Notifications",
      "icon": "",
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Mobile-Notification.svg",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "subMenu": [
        {
          "title": "Mails",
          "link": "/vendor/email-notifications",
          "icon": "fa-solid fa-envelope",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Emails.svg",
          "show": true
        },

      ]
    },
   /*  "settings": {
      "title": "Settings",
      "icon": "",
      "iconType": 'svg',
      "svgPath": "/assets/images/icon/Settings-svg-icon-1.svg",
      "active": "",
      "hideMenu": false,
      "expandMenu": false,
      "showMenu": true,
      "subMenu": [
        {
          "title": "Departments",
          "link": "/vendor/department-master",
          "icon": "fa-solid fa-building",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Departments-svg-icon-2.svg",
          "show": true
        },
        {
          "title": "Designations",
          "link": "/vendor/designation-master",
          "icon": "fa-solid fa-user-tie",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Designations-svg-icon-1.svg",
          "show": true
        },

        {
          "title": "PA/KPI goals",
          "link": "/vendor/kpi-master",
          "icon": "fa-solid fa-bullseye",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Performance-Appraisal-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "KPI eligibility",
          "link": "/vendor/kpi-eligibility-employees",
          "icon": "fa-solid fa-users-viewfinder",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/KPI-svg-icon-1.svg",
          "show": true
        },
       
        {
          "title": "Shifts",
          "link": "/vendor/shift-management",
          "icon": "fa-solid fa-business-time",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Shifts-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Salary Components",
          "link": "/vendor/salary-master",
          "icon": "fa-solid fa-wallet",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Salary-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Leave Masters",
          "link": "/vendor/leave-master",
          "icon": "fa-solid fa-wallet",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Leave-Master-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "OT Rules",
          "link": "/vendor/ot-rules",
          "icon": "fa-solid fa-wallet",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Overtime-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Holiday Calender",
          "link": "/vendor/holiday-calender",
          "icon": "fa-solid fa-wallet",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Holiday-calendar-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Salary Types",
          "link": "/vendor/employee-salary",
          "icon": "fa-solid fa-money-check-dollar",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Salary-svg-icon-4.svg",
          "show": true
        },
        {
          "title": "Employee Types",
          "link": "/vendor/employee-types",
          "icon": "fa-solid fa-address-card",
          "active": "",
          "iconType": 'svg',
          "svgPath": "/assets/images/icon/Employee-Types-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Employee Roles",
          "link": "/vendor/hrms-roles",
          "icon": "fa fa fa-calendar-check",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Employee-Roles-svg-icon-1.svg",
          "active": "",
          "show": true

        },
        {
          "title": "Asset Categories",
          "link": "/vendor/asserts",
          "icon": "",
          "iconType": "svg",
          "svgPath": "/assets/images/icon/Assets-Categories-svg-icon-1.svg",
          "active": "",
          "show": true

        },
        {
          "title": "Service Categories",
          "link": "/vendor/service-reqs",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath": "/assets/images/icon/Service-Categories-svg-icon-1.svg",
          "show": true
        },
        {
          "title": "Reimbursement projects",
          "link": "/vendor/project-list",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath": "/assets/images/icon/Reimbursement-projects-svg-icon-1.svg",
          "active": "",
          "show": true
        },
        
        {

          "title": "RTW Categories",
          "link": "/vendor/rtw-categorie",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath": "/assets/images/icon/RTW-Categories-svg-icon-1.svg",
          "active": "",
          "show": true
        },

        {
          "title": "Recognitions",
          "link": "/vendor/recognisations",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath": "/assets/images/icon/Employee-Recognition-svg-icon-2.svg",
          "active": "",
          "show": true
        },
        {
          "title": "Off Boarding",
          "link": "/vendor/off-boarding",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "svgPath": "/assets/images/icon/Employee-Recognition-svg-icon-2.svg",
          "active": "",
          "show": true
        },

        {
          "title": "Separation Categories",
          "link": "/vendor/sep-category",
          "iconType": "svg",
          "icon": "fa fa-wallet",
          "active": "",
          "svgPath": "/assets/images/icon/Service-Categories-svg-icon-1.svg",
          "show": true
        },

      ]
    }, */
  }
  @Output() requestToggle = new EventEmitter<void>();
  constructor(
    private router: Router,
    // private http: HttpClient, 
    private menuService: MenuService,
    private utilsService: UtilsService,
    private utilsDataService: UtilsDataService,
    private jobSeekerService: JobSeekerService,

  ) {
    // this.updateActiveLinks();
    // this.initializeProducts();
    // this.utilsService.profileActionData.subscribe((data:any)=>{
    //   console.log("RRRRR", data)
    //   // this.profileData= data.profileData;
    //  })
    this.utilsService.profileActionData.subscribe((data: any) => {
      console.log("RRRRR", data);
      this.profileData = data.profileData;
    });
    this.getMenus();


  }

  // get menuDisplayStatus() {
  //   return this.jobSeekerService.leftMenuDisplay();
  // }

  getMenus() {
    // this.menuService.getMenu.subscribe(data => {
    //   console.log('Menu Items:', data['VENDOR']);
    //   this.menuCustom = data['menu'];
    //   this.profileData.purchasedModules.forEach((ele: any)=>{
    //     this.menuCustom.push(this.matri_menu[ele.module_name])
    //       this.supportVisible = data['supportDisplay'] === true;

    //   }
    // )
    //   // this.menuCustom.push(this.matri_menu["MATRI"])
    //   // this.menuCustom.push(this.matri_menu["JOBS"])
    // });
    // const selectedApplications = this.utilsDataService.enabledVendorApplications
    // console.log("vvvvmmmm", selectedApplications)
    // this.menuService.getMenu.subscribe(data => {
    //   console.log('Menu Items:', data['VENDOR']);
    //   this.menuCustom = data['menu'];


    //   this.menuCustom?.push(this.matri_menu[selectedApplications])

    //   if (selectedApplications === "jobs") {
    //     this.menuCustom?.push(
    //         this.matri_menu['jobs_db'],
    //         this.matri_menu['advertisements']
    //       );
    //       console.log("mmmmmmnnnnbbb",this.menuCustom)
    //   }

    //   this.supportVisible = data['supportDisplay'] === true;

    // this.profileData.vendorApplicationModules.forEach((ele: any)=>{
    //   this.menuCustom?.push(this.matri_menu[ele.apllication_name])
    //     this.supportVisible = data['supportDisplay'] === true;
    //     console.log("vvvvvkkkklllaaa",this.menuCustom)

    // }
    // this.profileData.vendorApplicationModules.forEach((ele: any) => {
    //   const appName = ele.apllication_name;

    //   // Push base menu
    //   const menuItem = this.matri_menu[appName];
    //   if (menuItem) {
    //     this.menuCustom?.push(menuItem);
    //   }

    //   // If application name is "JOBS", push jobs DB menu/data too
    //   if (appName === "JOBS") {
    //     this.menuCustom?.push(
    //       this.matri_menu['JOBS_DB'],
    //       this.matri_menu['ADVERTS']
    //     );
    //   }


    //   // Set support visible flag
    //   this.supportVisible = data['supportDisplay'] === true;

    //   console.log("vvvvvkkkklllaaa", this.menuCustom);
    // });

    // First, collect all app names for easy lookup
    // const appNames = this.profileData.vendorApplicationModules.map((ele: any) => ele.apllication_name);

    // this.profileData.vendorApplicationModules.forEach((ele: any) => {
    //   const appName = ele.apllication_name;

    //   // Push base menu
    //   const menuItem = this.matri_menu[appName];
    //   if (menuItem) {
    //     this.menuCustom?.push(menuItem);
    //   }

    //   // If "JOBS", push JOBS_DB and conditionally ADVERTS if not already in appNames
    //   if (appName === "JOBS") {
    //     this.menuCustom?.push(this.matri_menu['JOBS_DB']);

    //     if (!appNames.includes("ADVERTS")) {
    //       this.menuCustom?.push(this.matri_menu['ADVERTS']);
    //     }
    //   }

    //   // Set support visible flag
    //   this.supportVisible = data['supportDisplay'] === true;
    // });



    // this.menuCustom.push(this.matri_menu["MATRI"])
    // this.menuCustom.push(this.matri_menu["JOBS"])

    const selectedApplications: string[] = this.utilsDataService.enabledVendorApplications;
    console.log("Selected Applications:", selectedApplications);
    console.log("Enabled Apps:", selectedApplications);

    this.menuService.getMenu.subscribe(data => {
      console.log("Menu Data:", data);

      // Ensure menuCustom is initialized
      this.menuCustom = data['menu'] || [];

      // Loop through selected apps and push their menu items
      selectedApplications.forEach(app => {
        const menuKey = app.toLowerCase(); // normalize to lowercase if needed
        const baseMenuItem = this.matri_menu[menuKey];
        if (baseMenuItem) {
          this.menuCustom.push(baseMenuItem);
        }

        // If "jobs" app, push extra menu items only if not already selected
        if (menuKey === 'jobs') {
          const hasAdvertsInApps = selectedApplications.includes('advertisements') || selectedApplications.includes('advertisements');

          this.menuCustom.push(this.matri_menu['jobs_db']);

          if (!hasAdvertsInApps && this.matri_menu['advertisements']) {
            this.menuCustom.push(this.matri_menu['advertisements']);
          }
        }
      });
      if (this.profileData.role === "VENDOR") {
        //this.menuCustom.push(this.matri_menu['hrms']);
        //this.menuCustom.push(this.matri_menu['approvals']);
        this.menuCustom.push(this.matri_menu['payments']);
        this.menuCustom.push(this.matri_menu['notifications']);
        //this.menuCustom.push(this.matri_menu['settings']);
      }
      if (this.profileData.role === "VENDOR_EMP") {
        //this.menuCustom.push(this.matri_menu['finance']);
        //this.menuCustom.push(this.matri_menu['approvalsEmp']);
        this.menuCustom.push(this.matri_menu['notifications']);
      }


      this.supportVisible = data['supportDisplay'] === true;

      console.log("Final menuCustom:", this.menuCustom);
    });

    // this.menuService.getMenu.subscribe(data => {
    //   console.log('Menu Items:', data['VENDOR']);
    //   this.menuCustom = data['menu'];
    //   this.profileData.vendorApplicationModules.forEach((ele: any)=>{
    //     this.menuCustom.push(this.matri_menu[ele.apllication_name])
    //       this.supportVisible = data['supportDisplay'] === true;

    //   }
    // )
    // });
  }

  setActive(i: number, j: number) {
    this.supportActive = false;
    console.log("BBBBBBB", this.menuCustom)
    const menuIndex: number = i;
    const subMenuIndex: number = j;
    this.menuCustom.forEach((menu: any, idx: number) => {

      // this.menuCustom[menuIndex].subMenu[subMenuIndex].active = 'active';
      menu.subMenu.forEach((subMenu: any, subIdx: number) => {
        if (menuIndex == idx && subMenuIndex == subIdx) {
          this.menuCustom[menuIndex].subMenu[subMenuIndex].active = 'active';
        } else {
          this.menuCustom[idx].subMenu[subIdx].active = '';
        }
      });
      this.menuCustom[idx].active = '';

      console.log("GGGGGG-" + menuIndex, this.menuCustom[menuIndex].active)
    });
    this.menuCustom[menuIndex].active = 'active';
  }

  deActive() {
    console.log("BBBBBBB", this.menuCustom)
    this.menuCustom.forEach((menu: any, menuIndex: number) => {
      // this.menuCustom[i].subMenu[j].active = 'active';
      menu.subMenu.forEach((subMenu: any, subMenuIndex: number) => {
        this.menuCustom[menuIndex].subMenu[subMenuIndex].active = '';
      })

      this.menuCustom[menuIndex].active = '';

    })


  }
  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }
  goTo(link: any) {
    this.router.navigate([link]);
    // this.updateActiveLinks();
  }

  logout() {
    this.router.navigate(['/login']);
  }

  onHover(menuItem) {
    if (window.innerWidth > 1200 && menuItem) {
      document.getElementById('unset').classList.add('sidebar-unset')
    } else {
      document.getElementById('unset').classList.remove('sidebar-unset')
    }
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActiveByRoute(event.urlAfterRedirects);
      }
    });

    // Also trigger on first load
    this.setActiveByRoute(this.router.url);
  }

  setActiveByRoute(currentUrl: string) {
    this.menuCustom.forEach((menu: any) => {
      menu.active = '';
      menu.expandMenu = false;

      menu.subMenu?.forEach((sub: any) => {
        sub.active = '';
        if (sub.link === currentUrl) {
          sub.active = 'active';
          menu.active = 'active';
          menu.expandMenu = true;
        }
      });
    });
  }

  openSidebarAndToggle(menu: any) {

    // If sidebar is collapsed → ask parent to open it
    if (this.collapsed) {
      this.requestToggle.emit();  // 🔥 CALLS setMenu() in parent
    }

    // Then toggle submenu
    menu.expandMenu = !menu.expandMenu;
  }

}
